export const SAVE_METAFLOW_MODAL = 'metaflow';
